import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate,useParams } from "react-router-dom";

export default function PromotionPage() {
  const navigate = useNavigate();
    const { storeId } = useParams();

  const handleClick = () => {
    if (!storeId) return;
    navigate(`/app/store/${storeId}`);
  };

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        background: `linear-gradient(135deg, #222 60%, #2B232D 100%)`,
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {/* 背景圖片（不改色票）如果要保留可放此處 */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: `url(${
            process.env.REACT_APP_API_ENDPOINT
          }/media/promo.png?${new Date().getTime()})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 1,
          zIndex: 1,
        }}
      />
      {/* 主按鈕區塊 */}
      <Box sx={{ position: "relative", zIndex: 2, textAlign: "center" }}>
        <Button
          variant="outlined"
          onClick={handleClick}
          sx={{
            mt: 5,
            borderWidth: 4,
            borderColor: "#00E6E6",
            backgroundColor: "#fff",
            color: "red",
            fontSize: "2rem",
            fontWeight: 700,
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            borderBottomLeftRadius: "35px",
            borderBottomRightRadius: "35px",
            px: 2,
            py: 0,
            "&:hover": {
              backgroundColor: "#fff",
              borderColor: "#00c8c8",
            },
          }}
        >
          立即前往
        </Button>
      </Box>
    </Box>
  );
}
